import { apiClient } from "./client";
import type { GetAppResponse, ListAppsResponse } from "./types";

// Mirrors CatalogService RPCs in console/proto/catalog.proto. Only the read
// endpoints are used by this app -- CreateApp/UpdateApp are catalog
// management operations out of scope for this task's marketplace browse
// page.

export async function listApps(params?: {
  category?: string;
  limit?: number;
  offset?: number;
}): Promise<ListAppsResponse> {
  const { data } = await apiClient.get<ListAppsResponse>("/apps", { params });
  return data;
}

export async function getApp(id: string): Promise<GetAppResponse> {
  const { data } = await apiClient.get<GetAppResponse>(`/apps/${id}`);
  return data;
}
